import { StocksPage } from "@/modules/stock/pages";
import { Layout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

enum Paths {
  Stocks = "stocks",
}

export const stockRoutes: RouteObject = {
  path: Paths.Stocks,
  element: <Layout />,
  handle: {
    breadcrumb: () => ({ key: "breadcrumb.stocks" })
  },
  children: [
    { path: "", element: <StocksPage /> },
  ],
};
